import React, { useMemo } from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '36px',
    [theme.breakpoints.up('lg')]: {
      padding: '30px',
      width: '519px',
    },
  },
  fieldContainer: {
    border: '1px solid #CAD6EA',
    borderRadius: '8px',
    display: 'block',
    padding: '8px 12px',
  },
  subtitle: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '18px',
    marginBottom: '20px',
    textAlign: 'left',
  },
  textLink: {
    color: '#2188FF',
    fontSize: '14px',
    lineHeight: '16px',
    marginBottom: '0px',
    textAlign: 'left',
  },
  title: {
    color: '#172B4D',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px',
    marginBottom: '5px',
    textAlign: 'left',
  },
}));

export default ({ linkResources }) => {
  const classes = useStyles();

  const virtualIds = useMemo(() => {
    return (linkResources || []).map(() => crypto.randomUUID());
  }, [linkResources]);

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>Download</Typography>
      <Typography className={classes.subtitle}>Click on the link to download the file.</Typography>

      <Grid container spacing={1}>
        {(linkResources || []).map((resource, idx) => (
          <Grid item xs={12} md={6} key={virtualIds[idx]}>
            <div className={classes.fieldContainer}>
              <a href={resource.link} download className={classes.textLink}>
                {(resource?.title || 'NO TITLE').toUpperCase()} #{idx + 1}
              </a>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
